import React, {useState} from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  InputGroup,
  Row
  // @ts-ignore
} from "reactstrap";

import { Formik, Form } from "formik";
import { authenticationService } from '../../services/authentication';
import { alertConstants } from "../../constants";
import AlertMessage from "../AlertMessage/AlertMessage";
import ClearableField from "./ClearableField";
import "./login.scss";
import {useHistory, useLocation} from "react-router-dom";
import * as yup from 'yup';
import * as omniApi from '../../ApiCalls';

function Login() {
  const location = useLocation<{ alertMsgs?: AlertMessageType[] }>();
  const history = useHistory();

  const [alerts, setAlerts] = useState(location.state?.alertMsgs ?? []);

  const loginSchema = yup.object({
    username: yup.string().required("Username is required"),
    password: yup.string().required("Password is required")
  });

  function addAlert(message: AlertMessageType) {
    setAlerts([message]);
  }

  function handleSubmit(values: { username: string, password: string }) {
    const redirect = sessionStorage.getItem('redirect') ?? '/'; // TODO: Replace with react-routing

    authenticationService.login(values.username, values.password)
      .then((landingPage) => {
        history.push(landingPage);

        if (redirect && landingPage !== '/resetPassword') {
          history.push(redirect);
        } else {
          history.push(landingPage)
        }

        sessionStorage.removeItem('redirect');
      })
      .catch((err) => {
        addAlert({
          msg: err.response.data ? err.response.data.errMsg : err.response.data,
          type: alertConstants.ERROR
        });
      })
  }

  function handleForgotPassword() {
    history.push('/resetPasswordPortal');
  }

  function handleProviderLogin() {
    window.location.href = omniApi.ssoAuthenticate();
  }

  return (
    <Formik initialValues={{ username: '', password: '' }} validationSchema={loginSchema} onSubmit={handleSubmit}>
      <div className={'app flex-row align-items-center'}>
        <Container>
          <Row className={'justify-content-center'}>
            {alerts.map((message, index) => <AlertMessage key={index} {...message} />)}
          </Row>
          <Row className={'justify-content-center'}>
            <Col md={8}>
              <CardGroup>
                <Card className={'p-4'}>
                  <CardBody>
                    <Form>
                      <Row className={'card-body-top-row'} />
                      <InputGroup className={'mb-3'}>
                        <ClearableField type={'text'} name={'username'} placeholder={'Username'} />
                      </InputGroup>
                      <InputGroup className={'mb-3'}>
                        <ClearableField type={'password'} name={'password'} placeholder={'Password'} />
                      </InputGroup>
                      <Row>
                        <Col xs={'auto'}>
                          <Button color={'link'} onClick={handleForgotPassword}>
                            Forgot Password
                          </Button>
                        </Col>
                        <Col />
                        <Col xs={'auto'}>
                          <Button color={'primary'} type={'submit'} className={'px-4'}>
                            Login
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
          <br />

          {/*<Row>*/}
          {/*  <Col />*/}
          {/*  <Col xs={'auto'}>*/}
          {/*    <Button color={'primary'} onClick={handleProviderLogin}>*/}
          {/*      Sign On With Provider*/}
          {/*    </Button>*/}
          {/*  </Col>*/}
          {/*  <Col />*/}
          {/*</Row>*/}

        </Container>
      </div>
    </Formik>
  )
}

export default Login;
